// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2G3Gw","left":"InfoRow_left__1IJq_"};